<template>
  <div class="">
    <label :for="labelFor" v-if="label" class="label--style">{{ label }}</label>
    <textarea
      :name="name"
      :placeholder="placeholder"
      :value="value"
      rows="4"
      @input="$emit('input', $event.target.value)"
      class="form--control"
    ></textarea>
  </div>
</template>
<script>
export default {
  name: "TextAreaComponent",
  props: {
    labelFor: {
      type: String,
    },
    label: {
      type: String,
    },
    value: {
      type: String,
    },
    name: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    type: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/field.scss";
@import "../assets/scss/font.scss";

.form--control {
  border: 1px solid rgb(222, 222, 222);
  border-radius: $field-border-radius;
  padding: 6px 10px;
  width: 100%;
}

.form--control::placeholder {
  font-size: 15px;
}

.label--style {
  font-weight: $font-weight-normal-2;
  font-size: $font-size-md;
  // margin-top: 10px;
  margin-bottom: 10px;
}

.form--control:focus {
  outline: none;
}
</style>
